




























import Vue from "vue";
import { formatCurrency } from "@/utils";

export default Vue.extend({
  props: {
    label: { type: String, required: false, default: "" },
    name: { type: String, required: false, default: "" },
    placeholder: { type: String, required: false, default: "" },
    value: { type: [String, Number], required: true },
    type: { type: String, required: false, default: "text" },
    disabled: { type: Boolean, required: false, default: false },
    currency: { type: Boolean, required: false, default: false },
    inline: { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      focus: false,
    };
  },
  computed: {
    pattern(): string | null {
      return this.isTypeNumber() ? "[0-9]*" : null;
    },
    inputmode(): string | null {
      return this.isTypeNumber() ? "numeric" : null;
    },
    currencyValue(): string {
      return formatCurrency(this.value);
    },
    model: {
      get(): string | number {
        return this.value;
      },
      set(val: string) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    focusIn() {
      this.focus = true;
    },
    focusOut() {
      this.focus = false;
    },
    isTypeNumber() {
      return this.type === "number";
    },
    formatCurrency: formatCurrency,
  },
});
